window.MioFeaturedDeals = window.MioFeaturedDeals || {};
window.MioFeaturedDeals.scriptPromises = window.MioFeaturedDeals.scriptPromises || {};
window.MioFeaturedDeals.shortDesktopQuery = '(min-width: 1280px) and (max-height: 1020px)';
window.MioFeaturedDeals.isShortDesktopLayout = function isShortDesktopLayout() {
    if (window.MioViewportLayout?.matches) {
      return window.MioViewportLayout.matches({ minWidth: 1280, maxHeight: 1020 });
    }

    return Boolean(window.matchMedia && window.matchMedia(window.MioFeaturedDeals.shortDesktopQuery).matches);
  };
window.MioFeaturedDeals.getResponsiveDatasetNumber = function getResponsiveDatasetNumber(element, key, fallback) {
    if (!element) return fallback;

    const readNumber = (name, defaultValue) => {
      const value = Number(element.dataset[name] || 0);
      return Number.isFinite(value) && value > 0 ? value : defaultValue;
    };

    const baseValue = readNumber(key, fallback);
    const responsiveKey = `${key}ShortDesktop`;

    return window.MioFeaturedDeals.isShortDesktopLayout()
      ? readNumber(responsiveKey, baseValue)
      : baseValue;
  };
window.MioFeaturedDeals.loadScriptOnce = function loadScriptOnce(src, isReady) {
    if (!src || (typeof isReady === 'function' && isReady())) {
      return Promise.resolve();
    }

    if (window.MioFeaturedDeals.scriptPromises[src]) {
      return window.MioFeaturedDeals.scriptPromises[src];
    }

    window.MioFeaturedDeals.scriptPromises[src] = new Promise((resolve, reject) => {
      const existing = Array.from(document.scripts).find((scriptEl) => scriptEl.src === src);

      if (existing) {
        if (typeof isReady !== 'function') {
          resolve();
          return;
        }

        const checkReady = () => {
          if (isReady()) {
            resolve();
            return;
          }

          window.setTimeout(checkReady, 30);
        };

        checkReady();
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.MioFeaturedDeals.scriptPromises[src];
  };

window.MioFeaturedDeals.initAsyncSection = function initAsyncSection(sectionId) {
    const sectionRoot = document.getElementById(`shopify-section-${sectionId}`);

    if (!sectionRoot) return;

    const shell = sectionRoot.querySelector('[data-mio-featured-deals-async]');
    if (!shell || shell.dataset.mioDealsAsyncReady === 'true') return;

    const target = shell.querySelector('[data-mio-async-deals-target]');
    const feedUrl = shell.dataset.feedUrl;

    if (!target || !feedUrl) return;

    shell.dataset.mioDealsAsyncReady = 'true';

    let hasLoaded = false;
    let observer = null;
    let idleHandle = null;

    const markFailed = () => {
      shell.dataset.mioDealsState = 'failed';
      shell.setAttribute('aria-busy', 'false');
    };

    const ensureCardBehaviours = () => Promise.all([
      window.MioFeaturedDeals.loadScriptOnce(
        shell.dataset.productFormSrc,
        () => window.customElements && window.customElements.get('product-form')
      ),
      window.MioFeaturedDeals.loadScriptOnce(
        shell.dataset.quickAddSrc,
        () => window.customElements && window.customElements.get('quick-add-modal')
      )
    ]);

    const loadDeals = () => {
      if (hasLoaded) return;
      hasLoaded = true;

      if (observer) observer.disconnect();
      if (idleHandle && window.cancelIdleCallback) window.cancelIdleCallback(idleHandle);

      shell.dataset.mioDealsState = 'loading';

      fetch(feedUrl, {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Deals feed failed with ${response.status}`);
          }

          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const feedWrapper = doc.getElementById('shopify-section-mio-featured-deals-feed');
          const feed = feedWrapper || doc.querySelector('[data-mio-featured-deals-feed]');

          if (!feed) {
            throw new Error('Deals feed payload missing');
          }

          return ensureCardBehaviours().then(() => feed);
        })
        .then((feed) => {
          if (feed.id === 'shopify-section-mio-featured-deals-feed') {
            target.replaceChildren(document.importNode(feed, true));
          } else {
            target.replaceChildren(...Array.from(feed.childNodes).map((node) => document.importNode(node, true)));
          }

          shell.dataset.mioDealsState = 'loaded';
          shell.setAttribute('aria-busy', 'false');

          window.requestAnimationFrame(() => {
            window.MioFeaturedDeals.initSection(sectionId);
          });
        })
        .catch((error) => {
          console.warn('[MioFeaturedDeals] Async deals load failed', error);
          markFailed();
        });
    };

    const rootMargin = shell.dataset.rootMargin || '1400px 0px';

    if (window.Shopify?.designMode) {
      loadDeals();
      return;
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          loadDeals();
        }
      }, { rootMargin });

      observer.observe(shell);
      // Modern browsers load on approach. Idle work must not bypass this observer.
      return;
    }

    const scheduleIdleLoad = () => {
      if ('requestIdleCallback' in window) {
        idleHandle = window.requestIdleCallback(loadDeals, { timeout: 3200 });
        return;
      }

      window.setTimeout(loadDeals, 1800);
    };

    const scheduleIdleAfterFirstRender = () => {
      window.requestAnimationFrame(scheduleIdleLoad);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleIdleAfterFirstRender, { once: true });
      return;
    }

    scheduleIdleAfterFirstRender();
  };

window.MioFeaturedDeals.initLatestSection = function initLatestSection(sectionId) {
    const sectionRoot = document.getElementById(`shopify-section-${sectionId}`);

    if (!sectionRoot) return;

    const shell = sectionRoot.querySelector('[data-mio-latest-async]');
    if (!shell || shell.dataset.mioLatestAsyncReady === 'true') return;

    const targetGrid = document.getElementById(`Slider-${sectionId}`);
    const feedUrl = shell.dataset.feedUrl;
    const feedSectionId = shell.dataset.feedSectionId || '';

    if (!targetGrid || !feedUrl) return;

    shell.dataset.mioLatestAsyncReady = 'true';

    const initialCount = Math.max(1, window.MioFeaturedDeals.getResponsiveDatasetNumber(shell, 'initialCount', 8) || 8);
    const renderCount = Math.max(
      initialCount,
      window.MioFeaturedDeals.getResponsiveDatasetNumber(shell, 'renderCount', initialCount * 3) || initialCount * 3
    );
    const maxColumnsToShow = Math.max(1, window.MioFeaturedDeals.getResponsiveDatasetNumber(shell, 'maxColumnsToShow', 4) || 4);
    const feedPageSize = Math.max(1, Number(shell.dataset.feedPageSize || 20) || 20);
    const latestFetchTimeout = Math.max(5000, Number(shell.dataset.mioLatestFetchTimeout || 12000) || 12000);
    const loadedProductKeys = new Set();
    let hasLoaded = false;
    let observer = null;
    let idleHandle = null;

    const markFailed = () => {
      shell.dataset.mioLatestState = 'failed';
      shell.setAttribute('aria-busy', 'false');
    };

    const ensureCardBehaviours = () => Promise.all([
      window.MioFeaturedDeals.loadScriptOnce(
        shell.dataset.productFormSrc,
        () => window.customElements && window.customElements.get('product-form')
      ),
      window.MioFeaturedDeals.loadScriptOnce(
        shell.dataset.quickAddSrc,
        () => window.customElements && window.customElements.get('quick-add-modal')
      )
    ]);

    const buildPageUrl = (pageNumber) => {
      const url = new URL(feedUrl, window.location.origin);
      if (feedSectionId) {
        url.searchParams.set('section_id', feedSectionId);
      }
      if (pageNumber > 1) {
        url.searchParams.set('page', String(pageNumber));
      }
      return url.toString();
    };

    const getProductKey = (item) => {
      if (item.dataset.mioProductId) return item.dataset.mioProductId;

      const productLink = item.querySelector('a[href*="/products/"]');
      if (!productLink) return '';

      return productLink.getAttribute('href').split('?')[0];
    };

    const fetchCollectionPageItems = async (pageNumber, signal) => {
      const response = await fetch(buildPageUrl(pageNumber), {
        credentials: 'same-origin',
        signal,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`Latest products page failed with ${response.status} for page ${pageNumber}`);
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return [...doc.querySelectorAll('#product-grid > .grid__item')];
    };

    const normalizeCardItem = (item, index) => {
      const isCollapsed = index >= initialCount;

      item.id = `Slide-${sectionId}-${index + 1}`;
      item.dataset.mioOriginalIndex = String(index + 1);
      item.hidden = isCollapsed;
      item.classList.toggle('mio-featured__item--collapsed', isCollapsed);
      item.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--cancel');

      if (isCollapsed) {
        item.setAttribute('data-mio-expand-item', '');
      } else {
        item.removeAttribute('data-mio-expand-item');
      }

      item.querySelectorAll('img').forEach((image) => {
        image.loading = index >= maxColumnsToShow ? 'lazy' : image.loading || 'eager';
        image.decoding = image.decoding || 'async';
      });

      return item;
    };

    const loadLatestProducts = async () => {
      if (hasLoaded) return;
      hasLoaded = true;

      if (observer) observer.disconnect();
      if (idleHandle && window.cancelIdleCallback) window.cancelIdleCallback(idleHandle);

      shell.dataset.mioLatestState = 'loading';

      try {
        const items = [];
        let pageNumber = 1;
        const abortController = new AbortController();
        const timeoutId = window.setTimeout(() => abortController.abort(), latestFetchTimeout);

        try {
          while (items.length < renderCount && pageNumber <= 4) {
            const pageItems = await fetchCollectionPageItems(pageNumber, abortController.signal);
            if (!pageItems.length) break;

            pageItems.forEach((item) => {
              const key = getProductKey(item);
              if (!key || loadedProductKeys.has(key) || items.length >= renderCount) return;

              loadedProductKeys.add(key);
              items.push(document.importNode(item, true));
            });

            if (pageItems.length < feedPageSize) break;
            pageNumber += 1;
          }
        } finally {
          window.clearTimeout(timeoutId);
        }

        if (!items.length) {
          throw new Error('Latest products payload did not include product cards');
        }

        await ensureCardBehaviours();

        targetGrid.replaceChildren(
          ...items.map((item, index) => normalizeCardItem(item, index))
        );

        targetGrid.dataset.mioVisibleLimit = String(initialCount);
        shell.dataset.mioLatestLoadedCount = String(items.length);
        shell.dataset.mioLatestState = 'loaded';
        shell.setAttribute('aria-busy', 'false');

        window.requestAnimationFrame(() => {
          window.MioFeaturedDeals.initSection(sectionId);
        });
      } catch (error) {
        console.warn('[MioFeaturedDeals] Latest products load failed', error);
        markFailed();
      }
    };

    const rootMargin = shell.dataset.rootMargin || '1400px 0px';

    if (window.Shopify?.designMode) {
      loadLatestProducts();
      return;
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          loadLatestProducts();
        }
      }, { rootMargin });

      observer.observe(shell);
      return;
    }

    const scheduleIdleLoad = () => {
      if ('requestIdleCallback' in window) {
        idleHandle = window.requestIdleCallback(loadLatestProducts, { timeout: 3200 });
        return;
      }

      window.setTimeout(loadLatestProducts, 1800);
    };

    const scheduleIdleAfterFirstRender = () => {
      window.requestAnimationFrame(scheduleIdleLoad);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleIdleAfterFirstRender, { once: true });
      return;
    }

    scheduleIdleAfterFirstRender();
  };

window.MioFeaturedDeals.initSection = function initSection(sectionId) {
    const sectionRoot = document.getElementById(`shopify-section-${sectionId}`);

    if (!sectionRoot) return;

    const parsePrice = (text) => {
      if (!text) return NaN;

      const compact = text.replace(/\s+/g, '');
      const match = compact.match(/[-+]?\d[\d,.]*/);

      if (!match) return NaN;

      let value = match[0];

      if (value.includes(',') && value.includes('.')) {
        value = value.replace(/,/g, '');
      } else if (value.includes(',') && !value.includes('.')) {
        value = value.replace(',', '.');
      }

      return Number(value);
    };

    const updateSaleBadges = () => {
      const cards = sectionRoot.querySelectorAll('.product-card-wrapper');

      cards.forEach((card) => {
        const badgeWrap = card.querySelector('.card__badge');
        if (!badgeWrap) return;

        const badgeList = badgeWrap.querySelectorAll('.badge.mio-sale-badge');
        if (!badgeList.length) return;

        const primaryBadge = badgeWrap.querySelector('.badge.mio-sale-badge');
        if (!primaryBadge) return;

        const price = card.querySelector('.price.price--on-sale');
        const originalBadgeText = primaryBadge.textContent.trim();

        primaryBadge.classList.remove('mio-sale-badge');

        badgeList.forEach((badge, index) => {
          badge.style.display = index === 0 ? '' : 'none';
        });

        if (!price) return;

        const regularPriceEl =
          price.querySelector('.price__regular .price-item--regular') ||
          price.querySelector('.price-item--regular');

        const salePriceEl =
          price.querySelector('.price__sale .price-item--sale') ||
          price.querySelector('.price-item--sale');

        const regularPrice = parsePrice(regularPriceEl ? regularPriceEl.textContent : '');
        const salePrice = parsePrice(salePriceEl ? salePriceEl.textContent : '');

        if (!Number.isFinite(regularPrice) || !Number.isFinite(salePrice) || regularPrice <= salePrice) {
          primaryBadge.textContent = originalBadgeText || 'SALE';
          primaryBadge.classList.add('mio-sale-badge');
          primaryBadge.setAttribute(
            'aria-label',
            originalBadgeText ? originalBadgeText : 'Sale'
          );
          return;
        }

        const discountPercent = Math.max(
          1,
          Math.round(((regularPrice - salePrice) / regularPrice) * 100)
        );

        primaryBadge.textContent = `${discountPercent}% off`;
        primaryBadge.classList.add('mio-sale-badge');
        primaryBadge.setAttribute('aria-label', `Save ${discountPercent}%`);
      });
    };

    const runBadgeUpdate = () => {
      window.requestAnimationFrame(updateSaleBadges);
    };

    const getCardDiscount = (item) => {
      const discountScore = Number(item.dataset.mioDiscountScore);

      if (Number.isFinite(discountScore)) {
        return discountScore;
      }

      const price = item.querySelector('.price.price--on-sale');

      if (!price) return -1;

      const regularPriceEl =
        price.querySelector('.price__regular .price-item--regular') ||
        price.querySelector('.price-item--regular');

      const salePriceEl =
        price.querySelector('.price__sale .price-item--sale') ||
        price.querySelector('.price-item--sale');

      const regularPrice = parsePrice(regularPriceEl ? regularPriceEl.textContent : '');
      const salePrice = parsePrice(salePriceEl ? salePriceEl.textContent : '');

      if (!Number.isFinite(regularPrice) || !Number.isFinite(salePrice) || regularPrice <= salePrice) {
        return -1;
      }

      return ((regularPrice - salePrice) / regularPrice) * 100;
    };

    const prepareDiscountSortedGrid = () => {
      const grid = sectionRoot.querySelector('[data-mio-discount-sort-grid]');

      if (!grid || grid.dataset.mioDiscountSorted === 'true') return;

      const visibleLimit = window.MioFeaturedDeals.getResponsiveDatasetNumber(
        grid,
        'mioVisibleLimit',
        Number(grid.dataset.mioVisibleLimit || 0)
      );
      const items = [...grid.children].filter((item) => item.classList.contains('grid__item'));

      items
        .map((item, index) => ({
          item,
          discount: getCardDiscount(item),
          originalIndex: Number(item.dataset.mioOriginalIndex || index)
        }))
        .sort((a, b) => {
          if (b.discount !== a.discount) return b.discount - a.discount;
          return a.originalIndex - b.originalIndex;
        })
        .forEach(({ item }, index) => {
          const isCollapsed = visibleLimit > 0 && index >= visibleLimit;

          item.hidden = isCollapsed;
          item.classList.toggle('mio-featured__item--collapsed', isCollapsed);
          item.classList.remove('mio-featured__item--revealed');

          if (isCollapsed) {
            item.setAttribute('data-mio-expand-item', '');
          } else {
            item.removeAttribute('data-mio-expand-item');
          }

          grid.appendChild(item);
        });

      grid.dataset.mioDiscountSorted = 'true';
    };

    const setupExpander = () => {
      const expander = sectionRoot.querySelector('[data-mio-featured-expander]');
      const expanderShell = sectionRoot.querySelector('.mio-featured-expander');
      const expanderLabel = expander ? expander.querySelector('.mio-featured-expander__label') : null;
      const collapseButton = sectionRoot.querySelector('[data-mio-featured-collapse]');

      if (!expander) return;

      const revealLabel = expander.dataset.mioRevealLabel || 'Show more deals';
      const viewAllLabel = expander.dataset.mioViewAllLabel || 'View all deals';
      const viewLessLabel = expander.dataset.mioViewLessLabel || 'View less';
      const viewAllUrl = expander.dataset.mioViewAllUrl || '';
      const moreBeyondRendered = expander.dataset.mioMoreBeyondRendered === 'true';
      const discountGrid = sectionRoot.querySelector('[data-mio-discount-sort-grid]');
      const gridVisibleLimit = discountGrid
        ? window.MioFeaturedDeals.getResponsiveDatasetNumber(discountGrid, 'mioVisibleLimit', Number(discountGrid.dataset.mioVisibleLimit || 8) || 8)
        : 8;
      const batchSize = Math.max(
        1,
        window.MioFeaturedDeals.getResponsiveDatasetNumber(expander, 'mioBatchSize', gridVisibleLimit) || gridVisibleLimit
      );
      const maxReveals = Math.max(1, Number(expander.dataset.mioMaxReveals || 2) || 2);
      const targetId = expander.getAttribute('aria-controls');
      const targetGrid = targetId ? document.getElementById(targetId) : null;

      if (!targetGrid) {
        if (expanderShell) expanderShell.hidden = true;
        return;
      }

      const initialVisibleLimit = Math.max(
        1,
        window.MioFeaturedDeals.getResponsiveDatasetNumber(targetGrid, 'mioVisibleLimit', Number(targetGrid.dataset.mioVisibleLimit || 0) || batchSize) || batchSize
      );

      const getHiddenItems = () => {
        const revealScope = targetGrid && sectionRoot.contains(targetGrid) ? targetGrid : sectionRoot;

        return [
          ...revealScope.querySelectorAll('[data-mio-expand-item][hidden], .mio-featured__item--collapsed[hidden]')
        ];
      };

      const getAllItems = () => {
        return [...targetGrid.querySelectorAll('.grid__item')];
      };

      const collapseToInitialState = () => {
        getAllItems().forEach((item, index) => {
          const isCollapsed = index >= initialVisibleLimit;

          item.hidden = isCollapsed;
          item.classList.toggle('mio-featured__item--collapsed', isCollapsed);
          item.classList.remove('mio-featured__item--revealed');

          if (isCollapsed) {
            item.setAttribute('data-mio-expand-item', '');
          } else {
            item.removeAttribute('data-mio-expand-item');
          }
        });

        expander.dataset.mioRevealCount = '0';
      };

      const syncExpanderState = () => {
        const revealCount = Number(expander.dataset.mioRevealCount || 0) || 0;
        const hiddenItems = getHiddenItems();
        const canRevealMore = revealCount < maxReveals && (hiddenItems.length > 0 || moreBeyondRendered);
        const canViewAll = revealCount >= maxReveals && viewAllUrl && (hiddenItems.length > 0 || moreBeyondRendered);
        const hasPrimaryAction = canRevealMore || canViewAll;

        if (!hiddenItems.length && !moreBeyondRendered && revealCount === 0) {
          if (expanderShell) expanderShell.hidden = true;
          if (collapseButton) collapseButton.hidden = true;
          return;
        }

        if (expanderShell) expanderShell.hidden = false;

        expander.hidden = !hasPrimaryAction;
        expander.dataset.mioMode = canViewAll ? 'view-all' : 'reveal';
        expander.setAttribute('aria-expanded', revealCount > 0 ? 'true' : 'false');

        if (expanderLabel) {
          expanderLabel.textContent = canViewAll ? viewAllLabel : revealLabel;
        }

        if (collapseButton) {
          collapseButton.textContent = viewLessLabel;
          collapseButton.hidden = revealCount === 0;
        }
      };

      const hiddenItems = getHiddenItems();

      if (!hiddenItems.length) {
        syncExpanderState();
        if (!moreBeyondRendered) return;
      }

      if (expanderShell) expanderShell.hidden = false;
      if (expander.dataset.mioExpanderReady === 'true') return;

      expander.dataset.mioExpanderReady = 'true';
      expander.dataset.mioRevealCount = expander.dataset.mioRevealCount || '0';
      syncExpanderState();

      expander.addEventListener('click', () => {
        if (expander.dataset.mioMode === 'view-all' && viewAllUrl) {
          window.location.href = viewAllUrl;
          return;
        }

        const hiddenItems = getHiddenItems();
        const revealCount = Number(expander.dataset.mioRevealCount || 0) || 0;

        if (!hiddenItems.length) {
          if (moreBeyondRendered && revealCount < maxReveals) {
            expander.dataset.mioRevealCount = String(revealCount + 1);
            syncExpanderState();
            return;
          }

          syncExpanderState();
          return;
        }

        hiddenItems.slice(0, batchSize).forEach((item, index) => {
          item.hidden = false;
          item.removeAttribute('data-mio-expand-item');
          item.style.setProperty('--mio-reveal-order', index);
          item.classList.remove('mio-featured__item--collapsed');
          item.classList.add('mio-featured__item--revealed');
        });

        expander.dataset.mioRevealCount = String(revealCount + 1);
        syncExpanderState();
        runBadgeUpdate();
      });

      if (collapseButton) {
        collapseButton.addEventListener('click', () => {
          collapseToInitialState();
          syncExpanderState();
          runBadgeUpdate();
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          prepareDiscountSortedGrid();
          runBadgeUpdate();
          setupExpander();
        },
        { once: true }
      );
    } else {
      prepareDiscountSortedGrid();
      runBadgeUpdate();
      setupExpander();
    }

    window.MioFeaturedDeals.sectionLoadHandlers = window.MioFeaturedDeals.sectionLoadHandlers || {};

    if (!window.MioFeaturedDeals.sectionLoadHandlers[sectionId]) {
      window.MioFeaturedDeals.sectionLoadHandlers[sectionId] = (event) => {
        if (event.detail && String(event.detail.sectionId) === String(sectionId)) {
          prepareDiscountSortedGrid();
          runBadgeUpdate();
          setupExpander();
        }
      };

      document.addEventListener('shopify:section:load', window.MioFeaturedDeals.sectionLoadHandlers[sectionId]);
    }
  };
